import { useEffect, useRef } from "react";

import { acquireSocket, releaseSocket } from "../socket/socket";

function readAccessToken() {
   if (typeof document === "undefined") return "";
   const match = document.cookie.match(/(?:^|;\s*)access_token=([^;]+)/);
   return match ? decodeURIComponent(match[1]) : "";
}

/**
 * Ascultă un eveniment de pe socketul comun al filei (de ex. „balance:update”).
 * După conectare se trimite „register”, ca serverul să pună socketul în camerele lui
 * (user:{id}, role:staff). Handlerul poate fi o funcție nouă la fiecare randare.
 */
export default function useSocketEvent(event, handler, enabled = true) {
   const handlerRef = useRef(handler);
   handlerRef.current = handler;

   useEffect(() => {
      if (!enabled || !event) return undefined;
      const socket = acquireSocket(readAccessToken());
      if (!socket) return undefined;

      const register = () => {
         try {
            socket.emit("register");
         } catch {}
      };
      const onEvent = (payload) => {
         try {
            handlerRef.current?.(payload);
         } catch {}
      };

      socket.on("connect", register);
      socket.on(event, onEvent);
      if (socket.connected) register();

      return () => {
         socket.off("connect", register);
         socket.off(event, onEvent);
         releaseSocket(socket);
      };
   }, [event, enabled]);
}
